import * as Yup from 'yup';

export const BasicInfoSchema = Yup.object().shape({
  institutionName: Yup.string().required('First name is required'),
  address: Yup.string(),
  facilityType: Yup.string().required('Facility type is required'),
  street: Yup.string().required('Please select your date of birth'),
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  state: Yup.string().required('State is required'),
  country: Yup.string().required('Please enter your country of residence'),
  bio: Yup.string().required('Write short note about yourself'),
  localGovernment: Yup.string().required('Please enter you LGA'),
});

export type BasicInfoDataType = Yup.InferType<typeof BasicInfoSchema>;

type InitialValues = {
  institutionName: string;
  address: string;
  facilityType: string;
  street: string;
  email: string;
  state: string;
  country: string;
  bio: string;
  localGovernment: string;
};

export const BasicInfoInitialValues: InitialValues = {
  institutionName: '',
  address: '',
  facilityType: '',
  street: '',
  email: '',
  state: '',
  country: '',
  bio: '',
  localGovernment: '',
};
